export function GalleryIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" className="w-full">
      <rect width="43.4711" height="43.4711" rx="21.7355" fill="white" />
      <rect width="43.4711" height="43.4711" rx="21.7355" fill="#C2C2C2" />
      <rect x="13.041" y="13.041" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="19.1992" y="13.041" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="25.3574" y="13.041" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="13.041" y="19.1992" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="19.1992" y="19.1992" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="25.3574" y="19.1992" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="13.041" y="25.3579" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="19.1992" y="25.3579" width="5.20335" height="5.20336" fill="#140D13" />
      <rect x="25.3574" y="25.3579" width="5.20335" height="5.20336" fill="#140D13" />
    </svg>
  );
}
